import {Capacitor, registerPlugin} from '@capacitor/core'
import {Keyboard, KeyboardStyle} from '@capacitor/keyboard'

// @capacitor-community/safe-area (packages/mobile) - ten plugin ustawia paski systemowe z capacitor.config.ts
// (SafeArea statusBarStyle / navigationBarStyle 'DARK'), wiec tylko on je przelacza (drugi plugin ustawialby
// te sama flage okna i wynik zalezalby od kolejnosci wywolan). 'DARK' = jasne ikony na ciemnym tle
type SystemBarsStyle = 'DARK' | 'LIGHT'
type SystemBarsType = 'STATUS_BAR' | 'NAVIGATION_BAR'

interface ISafeAreaPlugin {
  setSystemBarsStyle(options: {style: SystemBarsStyle, type: SystemBarsType}): Promise<void>
}

const SafeAreaPlugin = registerPlugin<ISafeAreaPlugin>('SafeArea')

const SYSTEM_BARS_TYPES: SystemBarsType[] = ['STATUS_BAR', 'NAVIGATION_BAR']

// Styl paskow systemowych (statusu i nawigacji / gestow na Androidzie; iOS stylizuje tylko pasek statusu) i klawiatury
// w aplikacji natywnej. Konfiguracja startowa jest pod ciemna aplikacje - w light-modern jasne ikony znikaja na jasnym
// tle strony. Fiord Night / Dark: nic nie wolamy, dopoki w tej sesji nie bylo light (konfiguracja startowa zostaje
// nietknieta); po przejsciu light -> ciemny przywracamy wartosci z konfiguracji ('DARK', Keyboard Dark)
let hasAppliedLightSystemBars = false

export function syncNativeSystemBarsStyle(isLightModern: boolean): void {
  if (!Capacitor.isNativePlatform() || (!isLightModern && !hasAppliedLightSystemBars)) {
    return
  }
  hasAppliedLightSystemBars = isLightModern
  if (Capacitor.isPluginAvailable('SafeArea')) {
    const style: SystemBarsStyle = isLightModern ? 'LIGHT' : 'DARK'
    for (const type of SYSTEM_BARS_TYPES) {
      SafeAreaPlugin.setSystemBarsStyle({
        style,
        type,
      }).catch(() => {
        // plugin niedostepny w tym osadzeniu - zostaje styl z konfiguracji
      })
    }
  }
  if (Capacitor.isPluginAvailable('Keyboard')) {
    Keyboard.setStyle({style: isLightModern ? KeyboardStyle.Light : KeyboardStyle.Dark}).catch(() => {
      // Android nie obsluguje stylu klawiatury
    })
  }
}
